import React, { useContext, useEffect } from 'react';
import Store from './../../../layouts/store/Store/Store';
import StoreView from './../../../views/store/StoreView/StoreView';
import Language from '../../../common/decorators/Language';
import { t } from '../../../common/components/T';
import { getStaticPropsStoreFunction, getLangPaths } from '../../api/_props';
import { useCategoriesData } from '../../../common/utils/utils';
import UserContext from '../../../common/utils/getContext';
import { useRouter } from 'next/router';

const StoreMain = ({ banners, categoriesData, categoriesMeta, translates, reviews }) => {
    const { setState } = useContext(UserContext);

    const { categories, loadMoreCategories } = useCategoriesData(categoriesData, categoriesMeta);

    const router = useRouter();

    useEffect(() => {
        if (router?.query?.pr === '1') {
            setState('showRegWindow', { type: 'password-reset' });
        }
        if (router?.query?.fpr === '1') {
            setState('showRegWindow', { type: 'finpassword-reset' });
        }
    }, [router]);

    return (
        <Language translates={translates} page={'/store'}>
            <Store
                alias='store'
                title={t('storePageTitle', 'Магазин', 'all', translates)}
                categories={categories}
                loadMoreCategories={loadMoreCategories}
                translates={translates}
            >
                <StoreView categories={categories} loadMoreCategories={loadMoreCategories} banners={banners} reviews={reviews} />
            </Store>
        </Language>
    );
};

export async function getStaticProps(ctx) {
    return await getStaticPropsStoreFunction(ctx, '/store');
}
export async function getStaticPaths() {
    const paths = await getLangPaths();
    return {
        paths,
        fallback: true
    };
}

export default StoreMain;
